import { render, staticRenderFns } from "./lessonForm.vue?vue&type=template&id=2e04baed&scoped=true&"
import script from "./lessonForm.vue?vue&type=script&lang=js&"
export * from "./lessonForm.vue?vue&type=script&lang=js&"
import style0 from "./lessonForm.vue?vue&type=style&index=0&id=2e04baed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e04baed",
  null
  
)

export default component.exports